import { Linkedin, Mail } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const footerLinks = {
    Explore: [
      { name: 'Industry Examples', href: '/industry-examples' },
      { name: 'Virtual Archives', href: '/virtual-archives' },
      { name: 'Catalog', href: '/catalog' }
    ],
    Company: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact Us', href: '/contact' },
      // { name: 'Careers', href: '#careers' },
      //{ name: 'Blog', href: '#blog' },
      //{ name: 'Press', href: '#press' }
    ],
    Support: [
      { name: 'Account Management', href: '/account' },
      { name: 'Privacy Policy', href: '/privacy-policy' },
      { name: 'FAQs', href: '/faq' },
      //{ name: 'Cookie Policy', href: '#cookies' },
      //{ name: 'GDPR', href: '#gdpr' }
    ]
  };

  const socialLinks = [
    //{ icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: 'https://linkedin.com/company/contextral', label: 'LinkedIn' },
    { icon: Mail, href: 'mailto:support@contextral.com', label: 'Email' }
  ];

  return (
    <footer className="relative overflow-hidden bg-ink-900 text-slate-300">
      <div className="absolute inset-0 bg-blueprint opacity-60" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-8">
          {/* Brand Section */}
          <div className="col-span-3 lg:col-span-2">
            <img
              src="/LogoWide.webp"
              alt="Contextral"
              className="h-8 w-auto mb-4 brightness-0 invert"
              width={224}
              height={32}
            />
            <p className="text-slate-400 mb-6 max-w-md">
              Secure AI workflow automation, built around the systems you already run,
              deployed in your environment and managed by our team.
            </p>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-ink-800 border border-ink-line rounded-lg flex items-center justify-center text-slate-300 hover:bg-primary hover:border-primary hover:text-white transition-colors duration-300"
                >
                  <social.icon aria-hidden="true" className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-sans text-xs uppercase tracking-[0.18em] text-slate-500 mb-4">{category}</h3>
              <ul className="space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <NavLink
                      to={link.href}
                      className="text-slate-300 hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-ink-line mt-12 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-slate-500 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Contextral. All rights reserved.
            </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
